/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
import * as _ from 'lodash';
import React, { useEffect, useState, useMemo } from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { setLevelData, setUnits } from '../../actions/HirarchyaAction';
import {
  fetchRolesApiDataByUser,
  fetchRolesByRoleId,
  fetchUnits,
  session,
} from '../../Service/APIService';
import Breadcrumb from './Breadcrumb';
import { constants } from '../../shared/constants';

const HirarchyDDL = ({ hirarchy, setLevelData, setUnits, appName }) => {
  const [roles, setRoles] = useState([]);
  const [levels, setLevels] = useState([]);
  const { APPS } = constants.core;

  // 2nd ddl
  const fetchRoles = (levelName, roleId, tabs, levelDdlId) => {
    const { memberId, roleId: sessionRoleId } = session.user();
    const obj =
      sessionRoleId === 1
        ? { id: session.client(), type: 'byClient' }
        : { id: memberId, type: 'byUser' };
    const roleName = _.replace(_.lowerCase(levelName), ' ', '');
    fetchRolesApiDataByUser(obj.type, roleName, obj.id, appName)
      .then((res) => {
        const data = res.data.statusCode === 200 ? res.data.result : [];
        if (roleId) {
          // first time load set data and send to redux
          let lavelLable, lavelValue, breadCrumbName;

          if (levelDdlId) {
            const selectedLevel = data.filter(
              (x) => x.displayId === Number(levelDdlId)
            );
            lavelLable = selectedLevel[0].displayName;
            lavelValue = selectedLevel[0].displayId;
            breadCrumbName = selectedLevel[0].breadCrumbName;
          } else {
            lavelLable = data[0].displayName;
            lavelValue = data[0].displayId;
            breadCrumbName = data[0].breadCrumbName;
          }
          const obj = {
            type: { label: levelName, value: roleId },
            level: { label: lavelLable, value: lavelValue },
            levelName,
            breadCrumbName,
            tabsList: tabs,
          };
          setLevelData({
            ...hirarchy,
            ...obj,
          });
        }
        setLevels(data);
      })
      .catch((err) => {
        console.log(err);
        setLevels([]);
      });
  };

  // 1st ddl
  const fetchLevels = (type, id) => {
    const { roleId } = session.user();
    fetchRolesByRoleId(roleId)
      .then((res) => {
        const data = res.data.statusCode === 200 ? res.data.result : [];
        setRoles(data);
        if (type && id) {
          const { levelName, roleId, tabsList } = data.find(
            (role) => role.levelName === type
          );
          fetchRoles(levelName, roleId, _.split(tabsList, ','), id); // 'roleId for first time auto load, id = 2nd ddl
        } else {
          fetchRoles(
            data[0].levelName,
            data[0].roleId,
            _.split(data[0].tabsList, ','),
            id
          ); // 'roleId for first time auto load
        }
      })
      .catch((err) => {
        console.log(err);
        setRoles([]);
      });
  };

  useEffect(() => {
    const encrypt = window.atob(window.location.search.slice(1));
    let type, id, typeId;
    if (encrypt) {
      const data = encrypt.split('&');
      if (data) {
        switch (data.length) {
          case 1:
            typeId = data[0].split('=');
            type = 'Division';
            id = typeId[1];
            break;
          case 2:
            typeId = data[1].split('=');
            type = 'Substation';
            id = typeId[1];
            break;
          case 3:
            typeId = data[2].split('=');
            type = 'Asset';
            id = typeId[1];
            break;

          default:
            break;
        }
      }
    }
    fetchLevels(type, id);
  }, []);

  useEffect(() => {
    if (hirarchy.type.value && hirarchy.level.value) {
      fetchUnits(hirarchy.type.label, hirarchy.level.value)
        .then((res) =>
          res.data.statusCode === 200
            ? setUnits(res.data.result)
            : res.data.message
        )
        .catch((err) => console.log(err));
    }
  }, [hirarchy.level.value]);

  const onRoleChange = (selected) => {
    const { levelName, tabsList } = roles.find(
      (role) => role.roleId === selected.value
    );
    const tabs = _.split(tabsList, ',');
    setLevelData({
      ...hirarchy,
      type: selected,
      level: {},
      tabsList: tabs,
    });
    fetchRoles(levelName, '', tabs);
  };

  const onLeveChange = (selected) => {
    const { breadCrumbName } = levels.find(
      (role) => role.displayId === selected.value
    );
    setLevelData({
      ...hirarchy,
      level: selected,
      breadCrumbName,
    });
  };

  // check AssetType id for Transformer list of Asset level
  const filteredLevels = useMemo(() => {
    return hirarchy.type.label === 'Asset' && appName === APPS.ASSET
      ? levels.filter((x) => x.assetTypeId === 2 || x.assetTypeId === 5)
      : levels;
  }, [levels, appName]);

  return (
    <Col md={12} style={{ marginBottom: '8px', marginTop: '8px' }}>
      <Row>
        <FormGroup>
          <Col md={4} sm={4} xs={12}>
            <label htmlFor="txtRoles" className="control-label">
              Select Level
            </label>
            <Select
              options={roles.map((x) => ({
                label: x.levelName,
                value: x.roleId,
              }))}
              id="txtRoles"
              value={hirarchy.type}
              onChange={onRoleChange}
            />
          </Col>

          <Col md={4} sm={4} xs={12}>
            <label htmlFor="txtHirarchy" className="control-label">
              Select {hirarchy.type.label}
            </label>
            <Select
              options={filteredLevels.map((x) => ({
                label: x.displayName,
                value: x.displayId,
              }))}
              id="txtLevels"
              value={hirarchy.level}
              onChange={onLeveChange}
            />
          </Col>
        </FormGroup>
      </Row>
      <Breadcrumb
        breadCrumbName={hirarchy.breadCrumbName}
        style={{ marginTop: '8px' }}
      />
    </Col>
  );
};

const mapStateToProps = (state) => ({
  hirarchy: state.HirarchyReducer.hirarchy,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setLevelData,
      setUnits,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HirarchyDDL);
